import { render, staticRenderFns } from "./ConfirmationDeleteReturnSettings.vue?vue&type=template&id=19b92a80"
import script from "./ConfirmationDeleteReturnSettings.vue?vue&type=script&lang=js"
export * from "./ConfirmationDeleteReturnSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports